import React from "react";
import Versions from "components/studio/rightnav/versions/Versions";
import "styles/css/studio/RightNav.css";


const RightNavView = ({
  flow,
  activeSection,
  isCollapsed,
  onClickCollapse
}) => (
  <div id="rightnav" className={`h-100 ${isCollapsed ? "collapsed" : ""} section-${activeSection}`}>
    {!isCollapsed ? (
      <>
        <div id="rightnav-close" onClick={onClickCollapse}>
          <i class="fas fa-angle-right"></i>
        </div>
        {activeSection == "versions" &&
          <Versions flow={flow} />
        }

      </>
    ) : null}
  </div>
);


export default RightNavView;